import React from 'react';
import ReactDOM from 'react-dom/client';
import { ClerkProvider } from '@clerk/clerk-react';
import './i18n';
import {
  createBrowserRouter,
  Navigate,
  RouterProvider,
} from 'react-router-dom';
import './index.css';
import reportWebVitals from './reportWebVitals';
import LocaleThemeProvider from './LocaleThemeProvider';

import App from './App';
import Account from './Account';
import PrivacyWeb from './PrivacyWeb';
import PublicOfferWeb from './PublicOfferWeb';
import Root from './Root';
import SsoCallback from './SsoCallback';
import { getClerkPublishableKey } from './clerkPublishableKey';

const clerkPublishableKey = getClerkPublishableKey();

const router = createBrowserRouter([
  {
    path: '/web-privacy',
    element: <Root><PrivacyWeb /></Root>,
  },
  {
    path: '/web-offer',
    element: <Root><PublicOfferWeb /></Root>,
  },
  {
    path: '/account',
    element: <Root><Account /></Root>,
  },
  {
    path: '/sso-callback',
    element: clerkPublishableKey ? (
      <SsoCallback />
    ) : (
      <Navigate to="/" replace />
    ),
  },
  {
    path: '/*',
    element: <Root><App /></Root>,
  },
]);

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <LocaleThemeProvider>
      {clerkPublishableKey ? (
        <ClerkProvider
          publishableKey={clerkPublishableKey}
          signInForceRedirectUrl="/account"
          signUpForceRedirectUrl="/account"
        >
          <RouterProvider router={router} />
        </ClerkProvider>
      ) : (
        <RouterProvider router={router} />
      )}
    </LocaleThemeProvider>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
